/*!
This file is part of CycloneDX JavaScript Library.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

SPDX-License-Identifier: Apache-2.0
Copyright (c) OWASP Foundation. All Rights Reserved.
*/

import {
  assertNodePackageJson as _assertNodePackageJson,
  isNodePackageJson as _isNodePackageJson,
  type NodePackageJson as _NodePackageJson
} from '../contrib/fromNodePackageJson/types'


export * from './cpe'
export * from './cwe'
export * from './integer'
export * from './mimeType'

// region deprecated re-exports

/**
 * Deprecated — TypeAlias of {@link Contrib.FromNodePackageJson.Types.NodePackageJson}.
 *
 * @deprecated Use `Contrib.FromNodePackageJson.Types.NodePackageJson` instead.
 */
export type NodePackageJson = _NodePackageJson

/**
 * Deprecated — Alias of {@link Contrib.FromNodePackageJson.Types.assertNodePackageJson}.
 *
 * @deprecated Use `Contrib.FromNodePackageJson.Types.assertNodePackageJson` instead.
 */
export const assertNodePackageJson = _assertNodePackageJson

/**
 * Deprecated — Alias of {@link Contrib.FromNodePackageJson.Types.isNodePackageJson}.
 *
 * @deprecated Use `Contrib.FromNodePackageJson.Types.isNodePackageJson` instead.
 */
export const isNodePackageJson = _isNodePackageJson

// endregion deprecated re-exports
